import { Component } from "react";
import { Routes, Route, Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import IUser from './types/user.type';


import EventBus from "./common/EventBus";
import React from "react";
import JobsView from "./coponents/jobs/JobsView";
import ViewHome from "./coponents/home/ViewHome";
import Login from "./coponents/login.component";
import Profile from "./coponents/profile.component";
import AuthService from "./services/AuthService";
import UsersView from "./coponents/users/UsersView";
import ViewJobApplications from "./coponents/job-applications/JobApplicationsView";
import logo from './assets/logo.svg';
import BoardUserDetails from "./coponents/users/user/BoardUserDetails";
import { AppConstants, Roles } from "./constants/AppConstants";
import JobApplicationsViewWrapper from "./coponents/job-applications/JobApplicationsViewWrapper";
import JobsViewWrapper from "./coponents/jobs/JobsViewWrapper";
import BoardJobApplication from "./coponents/job-applications/job-application/BoardJobApplication";
import JobApplicationViewWrapper from "./coponents/job-applications/job-application/JobApplicationViewWrapper";
import ImportDeliveries from "./coponents/deliveries/ImportDeliveries";
import ModeratorsView from "./coponents/moderators/ModeratorsView";
import AdminsView from "./coponents/admins/AdminsView";

type Props = {};

type State = {
    showOwnerBoard: boolean,
    showModeratorBoard: boolean,
    showAdminBoard: boolean,
    showPlatinumBoard: boolean,
    showAllOthers: boolean,
    currentUser: IUser | undefined
}

class App extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.logOut = this.logOut.bind(this);

        this.state = {
            showOwnerBoard: false,
            showModeratorBoard: false,
            showAdminBoard: false,
            showPlatinumBoard: false,
            showAllOthers: false,
            currentUser: undefined
        };
    }

    componentDidMount() {
        const user = AuthService.getCurrentUser();

        if (user) {
            this.setState({
                currentUser: user,
                showOwnerBoard: user.role.includes(Roles.OWNER),
                showModeratorBoard: user.role.includes(Roles.MODERATOR),
                showAdminBoard: user.role.includes(Roles.ADMIN),
                showPlatinumBoard: user.role.includes(Roles.PLATINUM),
                showAllOthers: user.role.includes(Roles.GOLD) || user.role.includes(Roles.PREMIUM)
            });
        }

        EventBus.on("logout", this.logOut);
    }

    componentWillUnmount() {
        EventBus.remove("logout", this.logOut);
    }

    logOut() {
        AuthService.logout();
        this.setState({
            showModeratorBoard: false,
            showAdminBoard: false,
            currentUser: undefined,
        });
    }

    render() {
        const { currentUser, showOwnerBoard, showModeratorBoard, showAdminBoard, showPlatinumBoard, showAllOthers } = this.state;

        return (
            <div>

                <nav className="navbar navbar-expand-lg navbar-dark bg-dark">

                    <img src={logo} alt="Locawork logo" style={{ height: "30px" }} />
                    <small className="ml-2">Locawork admin</small>

                    <button
                        className="navbar-toggler"
                        type="button"
                        data-toggle="collapse"
                        data-target="#navbarNav"
                        aria-controls="navbarNav"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className="collapse navbar-collapse" id="navbarNav">
                        {/* Left side nav */}
                        <ul className="navbar-nav mr-auto">
                            {/* Locawork Dropdown */}
                            <li className="nav-item dropdown">
                                <a
                                    className="nav-link dropdown-toggle"
                                    href="#"
                                    id="locaworkDropdown"
                                    role="button"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                >
                                    Locawork
                                </a>
                                <div className="dropdown-menu" aria-labelledby="locaworkDropdown">
                                    {showAllOthers && (
                                        <>
                                            <Link to={`/my-jobs/${currentUser?.id}`} className="dropdown-item">Jobs</Link>
                                            <Link to={`/my-job-applications/${currentUser?.id}`} className="dropdown-item">Job applications</Link>
                                        </>
                                    )}
                                    {showPlatinumBoard && (
                                        <>
                                            <Link to={`/my-jobs/${currentUser?.id}`} className="dropdown-item">Jobs</Link>
                                            <Link to={`/my-job-applications/${currentUser?.id}`} className="dropdown-item">Job applications</Link>
                                        </>
                                    )}
                                    {showOwnerBoard && (
                                        <>
                                            <Link to="/all-job-applications" className="dropdown-item">All job applications</Link>
                                        </>
                                    )}
                                    {showAdminBoard && (
                                        <>
                                            <Link to="/all-jobs" className="dropdown-item">All jobs</Link>
                                            <Link to="/all-job-applications" className="dropdown-item">All job applications</Link>
                                        </>
                                    )}
                                    {showModeratorBoard && (
                                        <>
                                            <Link to="/all-jobs" className="dropdown-item">All jobs</Link>
                                            <Link to="/all-job-applications" className="dropdown-item">All job applications</Link>
                                        </>
                                    )}
                                </div>
                            </li>

                            {/* Static items */}
                            <li className="nav-item dropdown">
                                <a
                                    className="nav-link dropdown-toggle"
                                    href="#"
                                    id="locaLogisticsDropdown"
                                    role="button"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                >
                                    LocaLogistics
                                </a>
                                <div className="dropdown-menu" aria-labelledby="locaLogisticsDropdown">
                                    {showAllOthers && (
                                        <>
                                            <Link to={`/my-deliveries/${currentUser?.id}`} className="dropdown-item">My deliveries</Link>
                                        </>
                                    )}
                                    {showPlatinumBoard && (
                                        <>
                                            <Link to={`/my-deliveries/${currentUser?.id}`} className="dropdown-item">My deliveries</Link>
                                            <Link to={`/all-deliveries/${currentUser?.id}`} className="dropdown-item">All deliveries</Link>
                                        </>
                                    )}
                                    {showOwnerBoard && (
                                        <>
                                            <Link to="/all-deliveries" className="dropdown-item">All deliveries</Link>
                                            <Link to="/import-deliveries" className="dropdown-item">Import deliveries</Link>
                                        </>
                                    )}
                                    {showAdminBoard && (
                                        <>
                                            <Link to="/all-deliveries" className="dropdown-item">All deliveries</Link>
                                            <Link to="/import-deliveries" className="dropdown-item">Import deliveries</Link>
                                        </>
                                    )}
                                    {showModeratorBoard && (
                                        <>
                                            <Link to="/all-jobs" className="dropdown-item">All jobs</Link>
                                            <Link to="/import-deliveries" className="dropdown-item">Import deliveries</Link>
                                        </>
                                    )}
                                </div>
                            </li>

                            <li className="nav-item">
                                <span className="nav-link">LocaEvent</span>
                            </li>

                            {/* Static items */}
                            <li className="nav-item dropdown">
                                <a
                                    className="nav-link dropdown-toggle"
                                    href="#"
                                    id="locaAccountsDropdown"
                                    role="button"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                >
                                    Account management
                                </a>
                                <div className="dropdown-menu" aria-labelledby="locaAccountsDropdown">
                                    {showOwnerBoard && (
                                        <>
                                            <Link to="/all-admins" className="dropdown-item">All admins</Link>
                                            <Link to="/all-moderators" className="dropdown-item">All moderators</Link>
                                            <Link to="/all-users" className="dropdown-item">All users</Link>

                                        </>
                                    )}
                                    {showAdminBoard && (
                                        <>
                                            <Link to="/all-admins" className="dropdown-item">All admins</Link>
                                            <Link to="/all-moderators" className="dropdown-item">All moderators</Link>
                                            <Link to="/all-users" className="dropdown-item">All users</Link>

                                        </>
                                    )}
                                    {showModeratorBoard && (
                                        <>
                                            <Link to="/all-users" className="dropdown-item">All users</Link>
                                        </>
                                    )}
                                </div>
                            </li>
                        </ul>

                        {/* Right side nav */}
                        <ul className="navbar-nav ml-auto">
                            {currentUser ? (
                                <>
                                    <li className="nav-item">
                                        <Link to="/profile" className="nav-link">{currentUser.email}</Link>
                                    </li>
                                    <li className="nav-item">
                                        <a href="/login" className="nav-link" onClick={this.logOut}>Logout</a>
                                    </li>
                                </>
                            ) : (
                                <li className="nav-item">
                                    <Link to="/login" className="nav-link">Login</Link>
                                </li>
                            )}
                        </ul>
                    </div>
                </nav>

                <div className="container mt-3">
                    <Routes>
                        <Route path="/" element={<ViewHome />} />
                        <Route path="/home" element={<ViewHome />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/my-profile" element={<Profile />} />
                        <Route path="/my-jobs/:userId" element={<JobsViewWrapper />} />
                        <Route path="/my-job-applications/:userId" element={<JobApplicationsViewWrapper />} />
                        <Route path='/user/:userId' element={<BoardUserDetails />} />
                        <Route path='/my-job-application/:jobApplicationId' element={<JobApplicationViewWrapper />} />

                        <Route path="/all-job-applications" element={<ViewJobApplications />} />
                        <Route path="/all-users" element={<UsersView />} />
                        <Route path="/all-jobs" element={<JobsView />} />
                        <Route path="/all-admins" element={<AdminsView />} />
                        <Route path="/all-moderators" element={<ModeratorsView />} />
                        <Route path="/import-deliveries" element={<ImportDeliveries />} />
                        <Route path="/order-subscription/:userId/:role" element={<UsersView />} />

                    </Routes>
                </div>

                { /*<AuthVerify logOut={this.logOut}/> */}
            </div>
        );
    }
}

export default App;
